/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Direct_BodyInputs */

const en_home_direct_body = /** @type {(inputs: Home_Direct_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Book with Ollio and you deal directly with the local team that looks after the apartments. Your booking is confirmed straight away, your details stay in one place, and you always know who to contact.`)
};

/**
* | output |
* | --- |
* | "Book with Ollio and you deal directly with the local team that looks after the apartments. Your booking is confirmed straight away, your details stay in one ..." |
*
* @param {Home_Direct_BodyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const home_direct_body = /** @type {((inputs?: Home_Direct_BodyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Direct_BodyInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_home_direct_body(inputs)
});